import styled from '@emotion/styled';

import Input from '../../Inputs/Input';
import PasswordInput from '../../Inputs/PasswordInput';
import Divider from './Divider';

export const Main = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const Container = styled.div`
  width: 100%;
`;

export const Section = styled.section`
  margin: 0 auto;
  text-align: center;
`;

export const AuthEmailInput = styled(Input)`
  margin: 0 0 0.75rem;
`;

export const AuthPasswordInput = styled(PasswordInput)`
  margin: 0 0 0.75rem;
`;

export const StyledDivider = styled(Divider)`
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 2px;
  margin: 1.25rem 0;
  text-transform: uppercase;
`;
